import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";

import { Theme } from "@radix-ui/themes";
import { ThemeContext } from "./Theme.js";
import { Container, Row, Col } from 'react-bootstrap';
import Home from './Home.js';
import NotFound from './NotFound.js';
export default function App() {

  const { theme } = useContext(ThemeContext);

  document.body.style = 'background: var(--accent-1)';

  return (
    <Router>
      <Theme accentColor="indigo" appearance={theme === 'dark-theme' ? "dark" : "light"}>
        <Container className={`App ${theme}`} fluid style={{ 
          marginTop: 0, 
          padding: 0,
          backgroundColor: '#fefefe'
          // background: 'linear-gradient(45deg, #e6f3ff, #f0e6ff, #ffe6f3, #e6e6ff, #f3e6ff)'
        }}>
          <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', marginTop: 0, marginLeft: 0, marginRight: 0 }}>
            <Col style={{ width: '100%' }}>
              <Routes>
                <Route path="/s/:id" element={<Home />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Col>
          </Row>
        </Container>
      </Theme>
    </Router>
  );

}
